import { SET_USER_PROFILE_DATA } from "../constants"

export const setProfileData = (data) => {
    return {
        type: SET_USER_PROFILE_DATA,
        payload: data
    }
}